export const selectAllCompanies = (state) => state.company.companies;
export const selectAllCompaniesStatus = (state) => state.company.status;
export const selectAllCompaniesError = (state) => state.company.error;
export const fullCompaniesList = (state) => state.company.originalCompanies;

export const addCompanyStatus = (state) => state.company.addCompanyStatus;
export const addCompanyError = (state) => state.company.addCompanyError;

export const selectedCompanyDetails = (state) => state.company.companyDetails;

export const editCompanyStatus = (state) => state.company.editCompanyStatus;
export const editCompanyError = (state) => state.company.editCompanyError;

export const selectedCompanyID = (state) => state.company.selectedCompanyID;
